import { values } from 'lodash'

export const ACTIVITY_LOG_ACTION = {
  CANCEL: 'CANCEL',
  CORPS_CHIEF_ACCEPT: 'CORPS_CHIEF_ACCEPT',
  CORPS_CHIEF_REJECT: 'CORPS_CHIEF_REJECT',
  MOUNTAIN_OFFICER_ACCEPT: 'MOUNTAIN_OFFICER_ACCEPT',
  MOUNTAIN_OFFICER_REJECT: 'MOUNTAIN_OFFICER_REJECT',
  UNIT_COMMANDER_ACCEPT: 'UNIT_COMMANDER_ACCEPT',
  UNIT_COMMANDER_REJECT: 'UNIT_COMMANDER_REJECT',
  SUBMIT: 'SUBMIT',
  RESCHEDULE: 'RESCHEDULE',
  START: 'START',
  FINISH: 'FINISH',
}

export const ACTIVITY_LOG_ACTION_ARRAY = values(ACTIVITY_LOG_ACTION)
